<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!setting">
    <tt-card>
        <tt-input ttLabel="p2_exportproc_name" [ttModel]="setting.p2_exportproc_name" ttReadonly></tt-input>
    </tt-card>

    <tt-list-legacy [listItems]="itemsListUserGroups" ltype="custom" [designVar]="'s12t0'" [optionfunc]="toggleChosen.bind(this)"></tt-list-legacy>

    <tt-card>
        <tt-button-save ttText="p2exportprocusergroups_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-input class="col-xs-12 sp-0" tt-label="p2_exportproc_name" tt-model="vm.model.setting.p2_exportproc_name" tt-change="vm.model.setting.p2_exportproc_name = $value" tt-readonly="true"></tt-input>
    </tt-card>

    <im-list-directive list-items="vm.model.itemsListUserGroups" badge="" ltype="custom" design-var="s12t0" optionfunc="vm.toggleChosen(item)"></im-list-directive>

    <tt-card>
        <tt-button-save class="col-xs-12 sp-0" tt-text="p2exportprocusergroups_save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>-->
